<template>
  <mk-drawer
    :visible="visible"
    :show-close="false"
    direction="rtl"
    size="40%"
    class="clue-track"
    hide-header
    :append-to-body="true"
    :modal-append-to-body="false"
    @close="onClose"
  >
    <div class="dialog-header">
      <span>线索来源轨迹</span>
      <div class="has-connect">
        <div>
          <mk-iconfont
            icon-class="guanbi"
            class="close cursor"
            @click.native="onClose"
          ></mk-iconfont>
        </div>
      </div>
    </div>
    <div class="mention-wrapper">
      <div class="mention">
        <mk-iconfont icon-class="jingshi"></mk-iconfont>你可以通过以下途径来找到线索
      </div>
    </div>
    <div
      v-if="!isError"
      v-loading="loading"
      class="clue-line-wrapper"
    >
      <div class="clue-line">
        <mk-timeline>
          <mk-timeline-item v-if="secondScene !== '2'">
            <div
              class="clue-item"
            >
              <template v-if="firstNodeInfo.secondScene !== '2'">
                <div class="clue-head-portrait-sale">
                  <template v-if="firstNodeInfo.name">
                    {{ firstNodeInfo.name[0] }}
                  </template>
                </div>
                <div class="clue-info">
                  <div class="clue-user-name">
                    {{ firstNodeInfo.name }}
                    <mk-iconfont
                      icon-class="user"
                      class="type-icon"
                    ></mk-iconfont>
                  </div>
                  <div class="clue-time">
                    <template v-if="firstNodeInfo.day">
                      <span class="time">{{ firstNodeInfo.day }} {{ firstNodeInfo.triggerTime && firstNodeInfo.triggerTime.slice(10,16) }}</span>
                    </template>
                    <template v-if="firstNodeInfo.shareType">
                      分享{{ firstNodeInfo.shareType === 'friend' ? '给好友' : '到朋友圈' }}
                    </template>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="clue-head-portrait-sale">
                  <template v-if="firstNodeInfo.avatarUrl">
                    <img :src="firstNodeInfo.avatarUrl">
                  </template>
                  <template v-if="!firstNodeInfo.avatarUrl && firstNodeInfo.name">
                    {{ firstNodeInfo.name[0] }}
                  </template>
                </div>
                <div class="clue-info">
                  <div class="clue-user-name">
                    {{ firstNodeInfo.name }}
                    <mk-iconfont
                      v-if="firstNodeInfo.isSyncWPContact"
                      icon-class="gzsj"
                      class="type-icon type-icon-gzsj"
                    ></mk-iconfont>
                  </div>
                  <div class="clue-time">
                    <template v-if="firstNodeInfo.day">
                      <span class="time">{{ firstNodeInfo.day }} {{ firstNodeInfo.triggerTime && firstNodeInfo.triggerTime.slice(10,16) }}</span>
                    </template>
                    <template v-if="firstNodeInfo.shareType">
                      分享{{ firstNodeInfo.shareType === 'friend' ? '给好友' : '到朋友圈' }}
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </mk-timeline-item>
          <mk-timeline-item
            v-for="(item, index) in timelineList"
            :key="index"
          >
            <template v-if="!item.isEtc">
              <div class="clue-item">
                <div class="clue-head-portrait">
                  <img
                    :src="item.avatarUrl"
                    class="img"
                  >
                </div>
                <div class="clue-info">
                  <div class="clue-user-name">
                    {{ item.nickName ? item.nickName: '未知的用户' }}
                    <mk-iconfont
                      v-if="!item.nickName"
                      icon-class="cannotsee"
                      class="type-icon"
                    ></mk-iconfont>
                    <mk-iconfont
                      v-if="clueInfo.isSyncWPContact"
                      icon-class="gzsj"
                      class="type-icon type-icon-gzsj"
                    ></mk-iconfont>
                  </div>
                  <div class="clue-time">
                    <span
                      v-if="item.triggerTime"
                      class="time"
                    >{{ item.day }} {{ item.triggerTime.slice(10,16) }}</span> 分享{{ item.shareTypeCn }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="clue-item">
                <mk-iconfont
                  icon-class="more"
                  class="etc-icon"
                ></mk-iconfont>
                <mk-iconfont
                  icon-class="more"
                  class="etc-icon"
                ></mk-iconfont>
              </div>
            </template>
          </mk-timeline-item>
          <mk-timeline-item>
            <div class="clue-item">
              <div class="clue-head-portrait">
                <img
                  :src="clueInfo.avatarUrl"
                  class="img"
                >
              </div>
              <div class="clue-info">
                <div class="clue-user-name">
                  {{ clueInfo.nickName }}
                  <mk-iconfont
                    v-if="clueInfo.isSyncWPContact"
                    icon-class="gzsj"
                    class="type-icon type-icon-gzsj"
                  ></mk-iconfont>
                </div>
                <div class="clue-time">
                  <span
                    v-if="clueInfo.firstVisitTime"
                    class="time"
                  >{{ clueInfo.firstVisitTime.slice(0,16) }}</span>
                  <template v-if="secondScene === '2'">
                    自主访问
                  </template>
                  <template v-else>
                    访问
                  </template>
                </div>
              </div>
            </div>
          </mk-timeline-item>
        </mk-timeline>
      </div>
    </div>
    <div
      v-else
      class="no-data"
    >
      <template v-if="!loading">
        暂无数据
      </template>
    </div>
  </mk-drawer>
</template>

<script>
export default {
  name: 'ClueTrack',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    unionId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 中间线索轨迹的信息，最多显示3条，多余中间使用省略号
      timelineList: [],
      // 销售的信息（或自主访问）
      firstNodeInfo: {},
      // 线索人的信息
      clueInfo: {},
      // 是否正在加载数据
      loading: false,
      // 是否出现异常，没有数据
      isError: false,
      secondScene: ''
    }
  },
  mounted () {
    this.wxclueTrailGet(this.unionId)
  },
  methods: {
    onClose () {
      this.$emit('update:visible', false)
    },
    // 获取链路轨迹
    // 'oT7YX1bMpHDjEP9eft83C4nSQotM'
    async wxclueTrailGet (unionId) {
      this.loading = true
      let res = await CLUEAPIS.ClueApi.clueTrailGet({
        unionId
      })
      this.loading = false
      if (res.success) {
        this.secondScene = res.data.secondScene
        let { data } = res
        this.secondScene = data.secondScene
        if (data.secondScene !== '2') {
          if (data.firstNodeInfo.secondScene !== '2') {
            this.firstNodeInfo = await this.$DexiePlguin.getUserById(
              data.firstNodeInfo.userId
            )
            this.firstNodeInfo = {
              name: this.firstNodeInfo.name,
              ...data.firstNodeInfo
            }
            // name: "营销前端研发"
            // userId: "16e7d809-e9b5-11e9-be2b-0242ac110003"
            // unionId: ""
            // nickName: ""
            // isSyncWPContact: false
            // avatarUrl: ""
            // secondScene: ""
            // event: "share"
            // shareType: "other"
            // triggerTime: ""
            // year: ""
            // month: ""
            // week: ""
            // day: ""
          } else {
            this.firstNodeInfo = {
              ...data.firstNodeInfo,
              name: data.firstNodeInfo.nickName
            }
          }
        }

        // 中间值，如果线索长度超过3，那么中间显示省略号
        data.traceInfos.forEach(item => {
          this.formatInfo(item)
        })
        // if (data.traceInfosLength > 3) {
        //   let etcData = {
        //     isEtc: true
        //   }
        //   data.traceInfos.splice(2, 0, etcData)
        // }
        this.timelineList = data.traceInfos
        this.clueInfo = data.clueInfo
      } else {
        this.isError = true
      }
    },
    // format信息
    formatInfo (itemInfo) {
      itemInfo.shareTypeCn =
        itemInfo.shareType === 'friend' ? '给好友' : '到朋友圈'
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #262626;
  font-size: 16px;
  height: 60px;
  padding: 0 20px;
  background: #fbfcfd;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 2px 2px 0 0;
  flex-shrink: 0;

  .close {
    font-size: 14px;
    color: #bfbfbf;
  }
}

.mention-wrapper {
  padding: 25px 70px 25px 20px;
  background: #fff;
}

.mention {
  font-size: 14px;
  padding-left: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  color: #595959;
  background-color: #fffbe6;
  border-radius: 4px;
  border: 1px solid rgba(255, 229, 143, 1);

  .icon-mk-jingshi {
    color: #faad14;
    margin-right: 8px;
  }
}

.clue-line-wrapper {
  height: calc(100% - 128px);
  padding: 10px 20px;
  background-color: #fafafa;
}

.clue-line {
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px 30px 0;
  border: 1px solid #e8e8e8;
  overflow-y: auto;

  .clue-item {
    display: flex;
    align-items: center;

    .etc-icon {
      font-size: 18px;

      &:last-child {
        margin-left: 1px;
      }
    }

    .clue-head-portrait {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .clue-head-portrait-sale {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      line-height: 36px;
      background-color: #fbfbfb;
      color: #009cff;
      font-size: 18px;
      text-align: center;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
      overflow: hidden;

      img {
        display: block;
        width: 100%;
      }
    }

    .clue-info {
      margin-left: 20px;
      font-size: 13px;
      color: #262626;

      .clue-user-name {
        color: #262626;

        .type-icon {
          margin-left: 5px;
        }

        .type-icon-gzsj {
          color: #009cff;
        }
      }

      .clue-time {
        margin-top: 6px;

        .time {
          color: #909399;
        }
      }
    }
  }

  /deep/ .el-timeline-item__tail {
    border-left: 1px solid #a0daff !important;
  }

  /deep/ .el-timeline-item__node--normal {
    left: 0 !important;
    width: 10px !important;
    height: 10px !important;
    background: #afdefc !important;
    border: 1px solid #009cff !important;
  }
}

.no-data {
  padding: 30px 0 0 20px;
}

.clue-track {
  * {
    box-shadow: none !important;
  }

  /deep/ .el-drawer__body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
